import axios from 'axios'

class ClientsService {
  uuidv4 () {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    )
  }

  getClientSettings (client) {
    let url = process.env.API + client + '/settings'
    return axios.get(url)
  }

  saveClientSettings (client, settings) {
    let url = process.env.API + client + '/settings'
    return axios.put(url, settings)
  }

  getAPISettings (client) {
    let url = process.env.API + client + '/api'
    return axios.get(url)
  }

  getAPINewKeys (client) {
    let url = process.env.API + client + '/api/new-keys'
    return axios.get(url)
  }
}

const clients = new ClientsService()

export default clients
export { clients }



// WEBPACK FOOTER //
// ./src/services/client.service.js